/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * This file is included for advanced development by
 * Shopify Agencies.  Modified versions of the theme
 * code are not supported by Shopify or Groupthought.
 *
 * In order to use this file you will need to change
 * theme.js to theme.dev.js in /layout/theme.liquid
 *
 */

(function () {
  "use strict";

  const CURRENT_PARTNER_STORAGE_KEY = "CURRENT_PARTNER_STORAGE_KEY";
  const PARTNER_PARAM_KEY = "pws";
  const PARTY_PARAM_KEY = "party";
  const REFERRER_PARAM_KEY = "ref";
  const OVERRIDE_PARTNER_STORAGE_KEY = "OVERRIDE_PARTNER_STORAGE_KEY";
  const SELECTED_LC = "SELECTED_LC";
  const CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY = "CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY";
  const PARTNER_KEY = `PARTNER-`;

  const storedCustomerKey = sessionStorage.getItem(CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY);

  class Repository {
    constructor() {
      this.baseURL = window.BASE_URL;
    }

    async setPrefPartner(customerID, partnerSite) {
      const url = `${this.baseURL}/customers/${customerID}/partner`;
      await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ partnerSite }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    }

    async removePrefPartner(customerID) {
      const url = `${this.baseURL}/customers/${customerID}/partner`;
      await fetch(url, { method: "DELETE" }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    }

    async getPartner(partnerSite) {
      const key = `${PARTNER_KEY}${partnerSite}`;

      const url = `${this.baseURL}/partners/search?searchType=WEBSITE&website=${partnerSite}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        if (data) sessionStorage.setItem(key, JSON.stringify(data));
        console.log(data);

        if (window.customer) {
          window.customer.exigoId = data?.partners?.[0]?.exigoId;
        }

        return data.partners?.[0];
      });
    }

    async getPartyByShareId(shareId) {
      const url = `${window.BACKEND_BASE_URL}/parties/${shareId}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        console.log("Party data:", data);
        return data;
      });
    }

    async searchPartner(params) {
      const url = new URL(`${this.baseURL}/partners/search`);
      Object.entries(params).forEach(([key, value]) => url.searchParams.append(key, value));
      console.log(url);
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        console.log(data);
        return data;
      });
    }
  }

  class PartnerSelect {
    static selectors = {
      partner_name: "[data-partner-name]",
      hidden_when_has_partner: "[data-hideon-partner]",
      show_when_has_partner: "[data-showon-partner]",
      show_when_no_partner: "[data-showon-no-partner]",
    };

    constructor() {
      // this.wrapper = container;
      this.partner_names = document.querySelectorAll(PartnerSelect.selectors.partner_name);

      this.repository = new Repository();

      this.init();
    }

    async init() {
      console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
      const partner = await this.loadPartnerFromSources();

      console.log("init:partner:", partner);
      if (partner) {
        const isPrefPartnerSet = !theme.partner_site && partner.siteName && theme.customer;
        // if (isPrefPartnerSet)
        //   await this.repository.setPrefPartner(
        //     theme.customer_id,
        //     partner.siteName
        //   );

        // TODO: update setPrefPartner fn
        // this.setPrefPartner(partner);

        // Restrict pws page web crawlers
        const metaTag = document.createElement("meta");
        metaTag.name = "robots";
        metaTag.content = "index,follow";
        const head = document.getElementsByTagName("head")[0];
        const marker = Array.from(head.childNodes).find(
          (node) => node.nodeType === 8 && node.textContent.includes("Search Engine Meta Tags")
        );

        if (marker) {
          marker.parentNode.insertBefore(metaTag, marker.nextSibling);
        } else {
          head.appendChild(metaTag);
        }
      } else {
        this.setNoPartner();
      }

      // load share cart url
      this.loadShareCart();

      document.addEventListener("theme:partner:update", (event) => {
        const partner = event.detail.partner;
        this.setPrefPartner(partner);
      });

      this.clearExtensionStorage();
      this.loadUrlAction();
      this.cartCheck();
    }

    async loadShareCart() {
      const urlSearchParam = new URLSearchParams(window.location.search);
      const cartId = urlSearchParam.get("share-cart");

      if (cartId) {
        console.log("share cartId:", cartId);

        const cart = await fetch(`${window.BASE_URL}/share-carts/${cartId}`)
          .then((res) => res.json())
          .catch((err) => console.log(err));
        console.log("share cart:", cart);

        if (cart) {
          let items = null;
          try {
            items = JSON.parse(cart.items);
          } catch (err) {
            console.log(err);
          }

          if (!items) return;

          $(document.body).addClass("loading-checkout");

          await fetch("/cart/clear.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
            redirect: "manual",
          });

          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items }),
            redirect: "manual",
          });

          // $('#mock-checkout-btn').click();
          // $(document.body).removeClass('loading-checkout');
          // window.location.replace('https://totallifechanges.com/checkout');
        }
      }
    }

    async cartCheck() {
      if (!window?.customer?.isPartner) return;
      const cart = await fetch("/cart.js")
        .then((res) => res.json())
        .catch((e) => console.log(e));
      const updates = {};

      cart.items.forEach(async (item) => {
        if (item.product_type === "Kit") {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) return;

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
        redirect: "manual",
      });
    }

    clearExtensionStorage() {
      try {
        const raw = localStorage.getItem("extensionStorage");
        const sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
        if (!raw || !sessionId) return;
        const extensionStorage = JSON.parse(raw);
        const selectedInsiderKey = Object.keys(extensionStorage).find((key) =>
          key.endsWith(`${sessionId}-CHECKOUT_SELECTED_INSIDER`)
        );
        if (selectedInsiderKey) {
          console.log("delete selectedInsiderKey:", selectedInsiderKey, extensionStorage[selectedInsiderKey]);
          delete extensionStorage[selectedInsiderKey];
          localStorage.setItem("extensionStorage", JSON.stringify(extensionStorage));
        }
      } catch (e) {
        console.log(e);
      }
    }

    async loadUrlAction() {
      const urlSearchParam = new URLSearchParams(window.location.search);
      const action = urlSearchParam.get("action");

      if (!action) return;

      if (action === "checkout_change_insider") {
        await new Promise((r) => setTimeout(r, 1000));
        const sponsorLocatorOpener = document.getElementById("sponsor-locator-opener");
        const clickEvent = new MouseEvent("click", { view: window, bubbles: true, cancelable: true });
        sponsorLocatorOpener.dispatchEvent(clickEvent);

        console.log("checkout_change_insider", $("#fyc-modal-overlay"));
        $("#fyc-modal-overlay").on("click", () => {
          let sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
          if (!sessionId) {
            sessionId = Date.now();
            sessionStorage.setItem("CHECKOUT_CUSTOM_SESSION_ID", sessionId);
          }
          const context = {
            curSite: localStorage.getItem(CURRENT_PARTNER_STORAGE_KEY) ?? null,
            customerId: window?.customer?.id,
            customerEmail: window?.customer?.email,
            isPartner: window?.customer?.isPartner,
            isQualifiedConsultant: window?.customer?.isQualifiedConsultant,
            partyId: sessionStorage.getItem("URL_PARTY") ?? null,
            taxExempt: window.customer ? window.customer.taxExempt : false,
            userType: window.customer ? window.customer.userType : null,
          };
          window.location.replace(
            `${document.location.origin}/checkout?attributes[SponsorID]=NONE&attributes[BrandAmbassadorID]=NONE&attributes[AllowInsiderAccess]=false&attributes[PartyID]=NONE&attributes[TotalCommissionable]=NONE&attributes[CommissionRate]=NONE&attributes[sessionID]=${sessionId}&attributes[context]=${btoa(
              JSON.stringify(context)
            )}`
          );
        });
      }
    }

    async loadPartnerFromSources() {
      const insiderLoggedIn = await this.isInsiderLoggedIn();

      // Prefer URL the customer arrived on (while persisting the preferred website)
      const urlSearchParam = new URLSearchParams(window.location.search);
      let urlWebsite = urlSearchParam.get(PARTNER_PARAM_KEY);
      const urlPartyId = urlSearchParam.get(PARTY_PARAM_KEY) || sessionStorage.getItem("URL_PARTY");
      if(urlWebsite !== null && urlWebsite !== undefined && window.globalSettingsVariable.shareCartName != null && window.globalSettingsVariable.shareCartName !== undefined) {
        var cartText = window.globalSettingsVariable.shareCartName.replace('[name]', urlWebsite);
        document.querySelector('.cart-drawer__inner .h5') ? document.querySelector('.cart-drawer__inner .h5').innerHTML = cartText : "";
      }
      if (!insiderLoggedIn && theme.customer && urlWebsite)
        sessionStorage.setItem(OVERRIDE_PARTNER_STORAGE_KEY, urlWebsite);
      else if (!theme.customer) sessionStorage.removeItem(OVERRIDE_PARTNER_STORAGE_KEY);

      const personalWebsite = window.location.href.match(/personalWebsite=(\d+)/)?.[1];

      console.log("personalWebsite", personalWebsite);
      if (personalWebsite) {
        const requestOptions = {
          method: "GET",
        };
        const partner = await fetch(
          `${window.BASE_URL}/partners/partner-search?searchType=SAP_ID&sapId=${personalWebsite}`,
          requestOptions
        ).then((res) => res.json());
        urlWebsite = partner?.personal_site;
      }

      console.log("urlPartyId", urlSearchParam.get(PARTY_PARAM_KEY), sessionStorage.getItem("URL_PARTY"));

      let partyWebsite = null;

      if (urlPartyId) {
        sessionStorage.setItem("URL_PARTY", urlPartyId);
        const currentURL = new URL(window.location);
        currentURL.searchParams.set(PARTY_PARAM_KEY, urlPartyId);
        window.history.replaceState(null, "nopartnerfound", currentURL);

        // Fetch party information using the shareId
        try {
          const partyData = await this.repository.getPartyByShareId(urlPartyId);
          if (partyData && partyData.site) {
            partyWebsite = partyData.site;
            console.log("Party website from API:", partyWebsite);
          }
        } catch (error) {
          console.error("Failed to fetch party data:", error);
        }
      }

      const customerWebsite = theme.partner_site;
      const overrideWebsite = sessionStorage.getItem(OVERRIDE_PARTNER_STORAGE_KEY);
      const storageCurrentWebsite = localStorage.getItem(CURRENT_PARTNER_STORAGE_KEY);

      // if insider logged in skip updating pws

      if (insiderLoggedIn) {
        return await this.repository.getPartner(theme.partner_site);
      }

      const partnerSite = partyWebsite || overrideWebsite || urlWebsite || storageCurrentWebsite || customerWebsite;
      if (!partnerSite) return;

      localStorage.setItem(CURRENT_PARTNER_STORAGE_KEY, partnerSite);
      const currentURL = new URL(window.location);
      currentURL.searchParams.set(PARTNER_PARAM_KEY, partnerSite);
      window.history.replaceState(null, "withpartner", currentURL);

      const partner = await this.repository.getPartner(partnerSite);

      this.updateHeader(partner);

      return partner;
    }

    async setPrefPartner(partner) {
      console.log(partner);
      localStorage.setItem(CURRENT_PARTNER_STORAGE_KEY, partner.siteName);
      this.current_partner = partner;
      document.dispatchEvent(new CustomEvent("theme:partner:set", { detail: { partner } }));
      const insiderLoggedIn = await this.isInsiderLoggedIn();
      this.updateUrlWithDesignerSite(partner.siteName);
      this.updateHeader(partner);
      this.updatePartnerElems();
      this.updateHomePage(partner.siteName);
    }

    setNoPartner() {
      this.show_when_no_partner = document.querySelectorAll(PartnerSelect.selectors.show_when_no_partner);
      this.show_when_no_partner.forEach((elem) => elem.classList.remove("d-none"));

      const currentURL = new URL(window.location);
      currentURL.searchParams.delete(PARTNER_PARAM_KEY);
      window.history.replaceState(null, "nopartnerfound", currentURL);
    }

    displayMyWebsite() {
      console.log("TODO");
    }

    updateUrlWithDesignerSite(siteName) {
      // skip setting pws param if shop_as link used
      const CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY = "CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY";
      const storedCustomerKey = sessionStorage.getItem(CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY);
      if (storedCustomerKey === undefined || storedCustomerKey === null) {
        const currentURL = new URL(window.location);
        currentURL.searchParams.set(PARTNER_PARAM_KEY, siteName);
        window.history.replaceState(null, "withpartner", currentURL);
      }
    }

    updateHeader(partnerData) {
      try {
      let consultantHeader = $(".selected-consultant");
      consultantHeader.css("display", "flex");
      $("#consultant-name").text(partnerData.displayName);
      if (partnerData.profileImage != null) {
        document.querySelector('[ data-sponser-profile-img]')?.setAttribute('src', partnerData.profileImage);
        document.querySelector('[ data-sponser-profile-img]')?.classList.remove('d-none');
      } else {
        document.querySelector('[ data-sponser-profile-img]')?.classList.add('d-none');
      }
      if (partnerData) {
        document.querySelector('[data-header-find-sponser]')?.classList.add('d-none');
        document.querySelector('[data-header-top-links]')?.classList.remove('d-none');
      }
    } catch {}
    }

    updatePartnerElems() {
      this.elems_to_hide = document.querySelectorAll(PartnerSelect.selectors.hidden_when_has_partner);
      this.elems_to_show = document.querySelectorAll(PartnerSelect.selectors.show_when_has_partner);
      this.elems_to_hide.forEach((elem) => elem.classList.add("d-none"));
      this.elems_to_show.forEach((elem) => elem.classList.remove("d-none"));

      document.dispatchEvent(new CustomEvent("theme:partner:render"));
    }

    async isInsiderLoggedIn() {
      console.log("isInsiderLoggedIn");
      const partnerSite = theme.partner_site;

      // if insider logged in skip updating pws
      if (partnerSite) {
        let currentSite = await this.repository.getPartner(partnerSite);
        console.log("currentSite:", currentSite);
        if (currentSite) {
          if (parseInt(currentSite.legacyResourceId) === __st.cid) {
            console.log("insider logged in");
            return true;
          }
        }
      }
      return false;
    }

    async updateHomePage(siteName) {
      if (theme.is_homepage) {
        const found = await this.repository.searchPartner({
          searchType: "WEBSITE",
          website: siteName,
        });
        console.log("found:", found);

        if (found.partners.length) {
          document.dispatchEvent(
            new CustomEvent("theme:partner:homepage", {
              detail: found.partners[0],
            })
          );
        }
      }
    }
  }

  // const partnerSelect = {
  // onLoad() {
  console.log("partnerSelect");
  const partnerSelect = new PartnerSelect();
  // },
  // };

  console.log("custom loaded");
  async function initModalEventListener() {
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    console.log("create postmessage listener");

    eventer(
      messageEvent,
      async function (e) {
        // console.log("listenting for postmessage")
        var key = e.message ? "message" : "data";
        var data = e[key];
        // console.log("postmessage: ", data)

        switch (data.type) {
          case "setPrefPartner":
            console.log("setPrefPartner event");
            // Set pref partner
            const partner = data.data;
            console.log(data.data);
            const partnerWebsite = partner.siteName;
            if (!this.repository) {
              this.repository = new Repository();
            }

            sessionStorage.setItem(OVERRIDE_PARTNER_STORAGE_KEY, partnerWebsite);
            localStorage.setItem(SELECTED_LC, JSON.stringify(partner))
            // if (theme.customer_id)
            //   await this.repository.setPrefPartner(
            //     theme.customer_id,
            //     partnerWebsite
            //   );
            document.dispatchEvent(new CustomEvent("theme:partner:update", { detail: { partner } }));
            postMessage("showConfirmation", "*"); //  `*` on any domain
            break;
          case "closeModal":
            console.log("switch Close modal");
            const modalName = "find-your-consultant";
            // MicroModal.close(modalName);
            // Close the modal using the modal-dialog custom element's hide() method
            const sponsorLocatorModal = document.getElementById("sponsor-locator");
            if (sponsorLocatorModal) {
              sponsorLocatorModal.hide();
            }

            const urlSearchParam = new URLSearchParams(window.location.search);
            const action = urlSearchParam.get("action");
            if (action && action === "checkout_change_insider") {
              let sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
              if (!sessionId) {
                sessionId = Date.now();
                sessionStorage.setItem("CHECKOUT_CUSTOM_SESSION_ID", sessionId);
              }
              const context = {
                curSite:
                  sessionStorage.getItem(OVERRIDE_PARTNER_STORAGE_KEY) ??
                  localStorage.getItem(CURRENT_PARTNER_STORAGE_KEY) ??
                  null,
                customerId: window?.customer?.id,
                customerEmail: window?.customer?.email,
                isPartner: window?.customer?.isPartner,
                isQualifiedConsultant: window?.customer?.isQualifiedConsultant,
                partyId: sessionStorage.getItem("URL_PARTY") ?? null,
                taxExempt: window.customer ? window.customer.taxExempt : false,
                userType: window.customer ? window.customer.userType : null,
              };
              window.location.replace(
                `${document.location.origin}/checkout?attributes[SponsorID]=NONE&attributes[BrandAmbassadorID]=NONE&attributes[AllowInsiderAccess]=false&attributes[PartyID]=NONE&attributes[TotalCommissionable]=NONE&attributes[CommissionRate]=NONE&attributes[sessionID]=${sessionId}&attributes[context]=${btoa(
                  JSON.stringify(context)
                )}`
              );
            }

            break;
          default:
            break;
        }
      },
      false
    );
  }

  async function checkoutChecks(cart, customerId) {
    return false;
    if (customerId === undefined) {
      // check if shop_as customer and pull customerId from sessionStorage
      const CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY = "CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY";
      const storedCustomerKey = sessionStorage.getItem(CURRENT_SHOP_AS_CUSTOMER_STORAGE_KEY);
      if (!storedCustomerKey !== undefined) {
        customerId = await getShopAsPartnerIdBySite(storedCustomerKey);
      }
    }
    // console.log("customerId: " + customerId)

    if (customerId !== undefined && customerId !== null) {
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerId: customerId,
          cart: cart,
        }),
      };
      console.log(options);

      var checkoutCheckstartTime = performance.now();
      let { qualifiedCheck, tagCheck } = await fetch(
        `${window.BASE_URL}/partners/checkout-checks`,
        options
      )
        .then((response) => {
          if (response.status !== 200) {
            return null;
          }
          return response.json();
        })
        .then((response) => {
          if (response === null) {
            return { qualifiedCheck: null, tagCheck: null };
          }
          return response;
        })
        .catch((err) => console.error(err));
      var checkoutCheckendTime = performance.now();

      console.log(`==== checkoutChecks took ${checkoutCheckendTime - checkoutCheckstartTime} milliseconds =====`);

      console.log("qualifiedCheck: " + JSON.stringify(qualifiedCheck));
      console.log("tagCheck: " + JSON.stringify(tagCheck));

      if (qualifiedCheck === null) {
        localStorage.setItem("qualifiedCheck", false);
        return false;
      }

      try {
        let cachedCheck =
          localStorage.getItem("qualifiedCheck") === "undefined"
            ? undefined
            : JSON.parse(localStorage.getItem("qualifiedCheck"));
        if (cachedCheck === undefined || cachedCheck !== qualifiedCheck.qualified) {
          localStorage.setItem("qualifiedCheck", qualifiedCheck.qualified);
        }
      } catch (error) {
        console.log(error);
      }

      return { qualifiedCheck, tagCheck };
    }
    return false;
  }

  async function configureCustomCheckout(cart) {

    try{
      const isAnyEvent = cart.items.find((item)=> item.product_type?.toLowerCase() == 'event');
      if (isAnyEvent) {
        return false;
      }

    console.log("========= congigureCustomCheckout start =========");

    const customCheckout = $("[name='checkout']");
    const checkoutError = $("[data-checkout-error]");
    const checkoutErrorText = $('[data-checkout-error-text]');
    let disableCheckout = false;
    let errorTextString = null;
    let shopAsCustomer = null;

    const foundGiftCards = cart.items.find((item) => item.product_type === 'Gift Card');
    const foundNonGiftCards = cart.items.find((item) => item.product_type !== 'Gift Card');
    if (foundGiftCards && (!window.theme.customer || foundNonGiftCards)) {
      disableCheckout = true;
      errorTextString = !window.theme.customer
        ? window.themeVariables.strings.giftCardPurchaseWithoutLoginError
        : window.themeVariables.strings.giftCardPurchaseWithOtherProductsError;
      checkoutError?.show();
      checkoutErrorText?.text(errorTextString);
    }

    const foundKit = cart.items.find((item) => item.product_type === 'Kit');
    if (foundKit && window.theme.is_partner) {
      disableCheckout = true;
      errorTextString = window.themeVariables.strings.kitPurchaseError;
      checkoutError?.show();
      checkoutErrorText?.text(errorTextString);
    }

    customCheckout.prop("disabled", disableCheckout);

    customCheckout.unbind("click").bind("click", async (e) => {
      e.stopPropagation();
      e.preventDefault();
      console.log("========= customCheckout clicked =========");


      if (window?.customer?.id) {
        await fetch(`${window.BACKEND_BASE_URL}/customers/sync`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: Number(window?.customer?.id)
          })
        })
        .then(_ => {})
        .catch(e => console.log(e));
      }

      customCheckout.prop("disabled", true);

      let urlCustomerData = "";
      let sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
      if (!sessionId) {
        sessionId = Date.now();
        sessionStorage.setItem("CHECKOUT_CUSTOM_SESSION_ID", sessionId);
      }

      // enrollment tax logic
      let enrollmentTax = false;

      const context = {
        curSite: localStorage.getItem("CURRENT_PARTNER_STORAGE_KEY") ?? null,
        customerId: window?.customer?.id,
        customerEmail: window?.customer?.email,
        isPartner: window?.customer?.isPartner,
        isQualifiedConsultant: window?.customer?.isQualifiedConsultant,
        partyId: sessionStorage.getItem("URL_PARTY") ?? null,
        enrollmentTax: enrollmentTax,
        BrandAmbassadorId: window.customer ? window.customer.exigoId : false,
        shopAsSelected: shopAsCustomer ? true : false,
        taxExempt: window.customer ? window.customer.taxExempt : false,
        userType: window.customer ? window.customer.userType : null,
      };

      const urlAttributes = `attributes[sessionID]=${sessionId}&attributes[context]=${btoa(JSON.stringify(context))}`;

      let urlParams = [urlAttributes, urlCustomerData].filter((e) => e !== "").join("&");

      let localeParam = window.theme.locale !== "en" ? `/${window.theme.locale}` : "";

      let checkoutURL = `${localeParam}/checkout?${urlParams}`;
      console.log("checkoutURL:", checkoutURL);

      window.location.href = checkoutURL;
    });

    console.log("========= congigureCustomCheckout end =========");
    }catch(err){
      console.log(err,'<==== err')
    }
  }

  document.addEventListener("cart:change", async function (event) {
    console.log("========= theme:cart:change =========");
    var cart = event.detail.cart;
    let customerId = ShopifyAnalytics.meta.page.customerId;

    configureKitBuyButtons(cart);
    configureGiftCardBuyButtons(cart);

    if (customerId !== null) {
      let oldQCCheck = localStorage.getItem("qualifiedCheck");
      let checks = await checkoutChecks(cart, customerId);
      console.log("checks: " + JSON.stringify(checks));

      if (
        oldQCCheck !== "undefined" &&
        checks !== false &&
        checks.qualifiedCheck.qualified !== JSON.parse(oldQCCheck)
      ) {
        document.dispatchEvent(new CustomEvent("qcCheck:cart:update", { bubbles: true }));
      }
    }

    var startTime = performance.now();
    configureCustomCheckout(cart);
    var endTime = performance.now();
    console.log("configureCustomCheckout took " + (endTime - startTime) + " milliseconds.");
  });

  function configureKitBuyButtons(cart) {
    const kitBuyButtons = $('[data-kit-buy-buttons] [type="submit"]');
    const foundKit = cart.items.find((item) => item.product_type === 'Kit');

    if (foundKit) kitBuyButtons.prop("disabled", true);
    else kitBuyButtons.prop("disabled", false);
  }

  function configureGiftCardBuyButtons(cart) {
    const giftCardBuyButtons = $('[data-gift-card-buy-buttons] [type="submit"]');
    const foundNonGiftCards = cart.items.find((item) => item.product_type !== 'Gift Card');

    if (foundNonGiftCards) giftCardBuyButtons.prop("disabled", true);
    else giftCardBuyButtons.prop("disabled", false);
  }

  initModalEventListener();

  async function initConfigureCustomCheckout() {
    const cart = await fetch('/cart.js').then(res => res.json()).catch(e => console.log(e));
    configureCustomCheckout(cart);
  }

  initConfigureCustomCheckout();

  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      if (links[i].getAttribute('id') != "viewAllIngredients") {
        links[i].target = "_blank";
        links[i].rel = "noreferrer noopener";
      }
    }
  }


  var tncBox = document.querySelector('#termsAndConditions');
  if (tncBox != null) {
    var allCheckbox = tncBox.querySelectorAll('input[type="checkbox"]');
    var submitBtn = tncBox.closest('form')?.querySelector('button');
    if (submitBtn != null) {
      submitBtn.setAttribute('disabled', 'disabled');
    }
    allCheckbox.forEach(input => {
      input.addEventListener('change', (e) => {
        var isEligable = true;
        allCheckbox.forEach(el => {
          if (!el.checked) {
            isEligable = false;
          }
        })
        if (isEligable) {
          submitBtn.removeAttribute('disabled');
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
        }
      })
    })
  }

  // TLC Party Preview
  class TLCPartyPreview extends HTMLElement {
    constructor() {
      super();
      console.log('TLCPartyPreview constructor called');
      // Cache para los datos de la fiesta
      this.cachedPartyData = null;
      this.cachedPartyId = null;
    }

    connectedCallback() {
      this.button = document.querySelector('[data-party-preview-button]');
      this.contentWrapper = this.querySelector('[data-party-preview-content]');
      this.overlay = this.querySelector('[data-party-preview-overlay]');
      this.closeButton = this.querySelector('[data-party-preview-close]');

      this.initEventListeners();
    }

    initEventListeners() {

      // Event listeners
      if (this.button) {
        this.button.addEventListener('click', () => {
          console.log('Button clicked');
          this.open();
        });
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          this.close();
        });
      }

      // Handle continue shopping button - same behavior as close button
      const continueShoppingButton = this.querySelector('.party-preview-cta__button');
      if (continueShoppingButton) {
        continueShoppingButton.addEventListener('click', () => {
          this.close();
        });
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => {
          this.close();
        });
      }

      // Prevenir que el click en el contenido cierre el panel
      if (this.contentWrapper) {
        this.contentWrapper.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      // Cerrar con tecla Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.contentWrapper && this.contentWrapper.classList.contains('open')) {
          this.close();
        }
      });
    }

    async open() {
      this.contentWrapper.style.display = 'flex';
      // Allow display to take effect before starting the transition
      requestAnimationFrame(() => {
        this.contentWrapper.classList.add('open');
        this.overlay.classList.add('open');
      });
      document.body.style.overflow = 'hidden';
      this.showLoadingState();
      await this.loadPartyDetails();
    }

    async loadPartyDetails() {
      const urlParty = sessionStorage.getItem("URL_PARTY");
      if (!urlParty) {
        this.hideLoadingState();
        return;
      }

      // Verificar si ya tenemos los datos cacheados para esta fiesta
      if (this.cachedPartyId === urlParty && this.cachedPartyData) {
        console.log('Using cached party data for:', urlParty);
        this.populatePartyDetails(this.cachedPartyData);
        this.hideLoadingState();
        return;
      }

      try {
        console.log('Loading party data from API for:', urlParty);
        const repository = new Repository();
        const partyData = await repository.getPartyByShareId(urlParty);
        if (partyData) {
          // Guardar en caché
          this.cachedPartyData = partyData;
          this.cachedPartyId = urlParty;
          this.populatePartyDetails(partyData);
        }
        this.hideLoadingState();
      } catch (error) {
        console.error('Failed to load party details:', error);
        this.hideLoadingState();
      }
    }

    populatePartyDetails(partyData) {
      populatePartyDetailsShared(this.contentWrapper, partyData);
    }

    showLoadingState() {
      const loadingElement = this.contentWrapper.querySelector('[data-party-loading]');
      const statusSection = this.contentWrapper.querySelector('.party-preview-status');
      const heroSection = this.contentWrapper.querySelector('.party-preview-hero');
      const infoSection = this.contentWrapper.querySelector('.party-preview-info');

      if (loadingElement) {
        loadingElement.style.display = 'flex';
      }
      // Ocultar "You are now shopping"
      if (statusSection) {
        statusSection.style.display = 'none';
      }
      // Ocultar toda la sección héroe (título, host, imagen)
      if (heroSection) {
        heroSection.style.display = 'none';
      }
      // Ocultar el título y los detalles de la info
      if (infoSection) {
        const title = infoSection.querySelector('.party-preview-info__title');
        const details = infoSection.querySelector('.party-preview-info__details');
        if (title) {
          title.style.display = 'none';
        }
        if (details) {
          details.style.display = 'none';
        }
      }
    }

    hideLoadingState() {
      const loadingElement = this.contentWrapper.querySelector('[data-party-loading]');
      const statusSection = this.contentWrapper.querySelector('.party-preview-status');
      const heroSection = this.contentWrapper.querySelector('.party-preview-hero');
      const infoSection = this.contentWrapper.querySelector('.party-preview-info');

      if (loadingElement) {
        loadingElement.style.display = 'none';
      }
      // Mostrar "You are now shopping"
      if (statusSection) {
        statusSection.style.display = 'block';
      }
      // Mostrar toda la sección héroe
      if (heroSection) {
        heroSection.style.display = 'block';
      }
      // Mostrar el título y los detalles de la info
      if (infoSection) {
        const title = infoSection.querySelector('.party-preview-info__title');
        const details = infoSection.querySelector('.party-preview-info__details');
        if (title) {
          title.style.display = 'block';
        }
        if (details) {
          details.style.display = 'flex';
        }
      }
    }

    close() {
      this.contentWrapper.classList.remove('open');
      this.overlay.classList.remove('open');
      document.body.style.overflow = '';
      // Hide after the slide-out transition completes (500ms matches CSS transition)
      setTimeout(() => {
        if (!this.contentWrapper.classList.contains('open')) {
          this.contentWrapper.style.display = 'none';
        }
      }, 500);
    }


  }

  customElements.define('tlc-party-preview', TLCPartyPreview);

  // Party Visibility Controller
  class PartyVisibilityController {
    constructor() {
      this.triggerElement = document.getElementById('party-preview-trigger');
      this.checkPartyVisibility();
      this.watchSessionStorage();
    }

    checkPartyVisibility() {
      const urlParty = sessionStorage.getItem("URL_PARTY");
      const visible = urlParty && urlParty.trim() !== '';
      if (this.triggerElement) {
        this.triggerElement.classList.toggle('is-active', visible);
        const btn = this.triggerElement.querySelector('[data-party-preview-button]');
        if (btn) btn.style.transform = visible ? 'translateX(-120px)' : 'translateX(-300px)';
      }
    }

    watchSessionStorage() {
      // Watch for sessionStorage changes
      const originalSetItem = sessionStorage.setItem;
      const originalRemoveItem = sessionStorage.removeItem;
      const self = this;

      sessionStorage.setItem = function(key, value) {
        originalSetItem.apply(this, arguments);
        if (key === "URL_PARTY") {
          self.checkPartyVisibility();
          // Limpiar caché si cambió el ID de la fiesta
          self.clearPartyCacheIfNeeded(value);
        }
      };

      sessionStorage.removeItem = function(key) {
        originalRemoveItem.apply(this, arguments);
        if (key === "URL_PARTY") {
          self.checkPartyVisibility();
          // Limpiar caché cuando se remueva URL_PARTY
          self.clearPartyCache();
        }
      };
    }

    clearPartyCacheIfNeeded(newPartyId) {
      const partyPreviewElement = document.querySelector('tlc-party-preview');
      if (partyPreviewElement && partyPreviewElement.cachedPartyId !== newPartyId) {
        partyPreviewElement.cachedPartyData = null;
        partyPreviewElement.cachedPartyId = null;
      }
    }

    clearPartyCache() {
      const partyPreviewElement = document.querySelector('tlc-party-preview');
      if (partyPreviewElement) {
        partyPreviewElement.cachedPartyData = null;
        partyPreviewElement.cachedPartyId = null;
      }
    }
  }

  // Initialize party visibility controller
  function initPartyVisibilityController() {
    new PartyVisibilityController();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPartyVisibilityController);
  } else {
    initPartyVisibilityController();
  }

  // Shared function to populate party details
  function populatePartyDetailsShared(contentWrapper, partyData) {
    console.log('Populating party details with data:', partyData);

    // Update party title
    const titleElement = contentWrapper.querySelector('.party-preview-title');
    if (titleElement && partyData.title) {
      titleElement.textContent = partyData.title;
    }

    // Update host information
    const hostElement = contentWrapper.querySelector('.party-preview-host-name');
    if (hostElement && partyData.hostName) {
      hostElement.textContent = partyData.hostName;
    }
    const locale = (window.theme && window.theme.locale) ? window.theme.locale : 'en';
    // Update party link expiration (7 days after party date)
    const expirationElement = contentWrapper.querySelector('.party-preview-party-link_expires');
    if (expirationElement && partyData.date) {
      // Parse date as local time to avoid timezone issues
      const partyDate = new Date(partyData.date + 'T00:00:00');
      const expirationDate = new Date(partyDate);
      expirationDate.setDate(partyDate.getDate() + 7);
      const formattedExpiration = expirationDate.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      expirationElement.innerHTML = formattedExpiration;
    }

    // Update party info details
    const infoItems = contentWrapper.querySelectorAll('.party-info-item span');
    console.log('Found info items:', infoItems.length, infoItems);

    if (infoItems.length >= 4) {
      // Update date (first info item)
      if (partyData.date) {
        // Parse date as local time to avoid timezone issues
        const date = new Date(partyData.date + 'T00:00:00');
        const formattedDate = date.toLocaleDateString(locale, {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
        infoItems[0].textContent = formattedDate;
      }

      // Update time (second info item)
      if (partyData.startTime) {
        const [hours, minutes] = partyData.startTime.split(':');
        const time = new Date();
        time.setHours(parseInt(hours), parseInt(minutes));
        const locale = (window.theme && window.theme.locale) ? window.theme.locale : 'en';
        const formattedTime = time.toLocaleTimeString(locale, {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
        infoItems[1].textContent = formattedTime;
      }

      // Update location (third info item)
      console.log('Address data:', {
        address1: partyData.address1,
        address2: partyData.address2,
        city: partyData.city,
        provinceCode: partyData.provinceCode,
        zip: partyData.zip
      });

      if (partyData.address1) {
        let address = partyData.address1;
        if (partyData.address2) {
          address += `, ${partyData.address2}`;
        }
        if (partyData.city) {
          address += `, ${partyData.city}`;
        }
        if (partyData.provinceCode) {
          address += `, ${partyData.provinceCode}`;
        }
        if (partyData.zip) {
          address += ` ${partyData.zip}`;
        }
        console.log('Constructed address:', address);
        console.log('Setting address on element:', infoItems[2]);
        infoItems[2].textContent = address;
      } else {
        console.log('No address1 found in party data');
      }

      // Update party type (fourth info item)
      if (partyData.partyType) {
        const typeText = partyData.partyType === 'IN_PERSON' ? 'In Person' :
                        partyData.partyType === 'VIRTUAL' ? 'Virtual' :
                        partyData.partyType === 'HYBRID' ? 'Hybrid' : partyData.partyType;
        infoItems[3].textContent = typeText;
      }
    }

    // Update meet link if available and set up copy button
    const copyLinkBtn = contentWrapper.querySelector('.copy-link-btn');
    if (partyData.meetLink) {
      // Store the meetLink in a data attribute and enable the button
      if (copyLinkBtn) {
        copyLinkBtn.dataset.meetLink = partyData.meetLink;
        copyLinkBtn.style.display = 'flex';

        // Remove any existing click handler by cloning the node
        const newCopyBtn = copyLinkBtn.cloneNode(true);
        copyLinkBtn.parentNode.replaceChild(newCopyBtn, copyLinkBtn);

        // Add click handler to the new button
        newCopyBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          const linkToCopy = newCopyBtn.dataset.meetLink;
          console.log('Copying link:', linkToCopy);

          try {
            await navigator.clipboard.writeText(linkToCopy);
            // Visual feedback
            newCopyBtn.textContent = 'Copied!';
            setTimeout(() => {
              newCopyBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" stroke-width="2"/>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" stroke-width="2"/>
              </svg>
              Copy Link`;
            }, 2000);
          } catch (err) {
            console.error('Failed to copy text: ', err);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = linkToCopy;
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            document.body.appendChild(textArea);
            textArea.select();
            try {
              document.execCommand('copy');
              newCopyBtn.textContent = 'Copied!';
              setTimeout(() => {
                newCopyBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" stroke-width="2"/>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" stroke-width="2"/>
                </svg>
                Copy Link`;
              }, 2000);
            } catch (fallbackErr) {
              console.error('Fallback copy failed:', fallbackErr);
            }
            document.body.removeChild(textArea);
          }
        });
      }
    } else {
      // Hide the copy button if no meetLink is available
      if (copyLinkBtn) {
        copyLinkBtn.style.display = 'none';
      }
    }
  }

})();
